import MDropdownButton from "./MDropdownButton.vue";
export default MDropdownButton;
